var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/nam.phamanh/Documents/Nam/git/cs/lazada/node_modules/_nunjucks-loader@2.4.9@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/extension/express/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"express-head\">\n    <span>";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "tracking")), env.opts.autoescape);
output += "</span>\n</div>\n<div class=\"express-body\">\n    <div class=\"date\">\n       ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "date"), env.opts.autoescape);
output += "\n    </div>\n    <div class=\"express-body-progress\">\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "status");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n           ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 1) {
output += "\n               <i class=\"dot ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"className"), env.opts.autoescape);
output += "\"></i>\n               <i class=\"bar ";
if((runtime.memberLookup((t_4),"className") == "current")) {
output += "un";
;
}
else {
;
}
output += "\"></i>\n           ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 2) {
output += "\n               <i class=\"dot ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"className"), env.opts.autoescape);
output += "\"></i>\n           ";
;
}
else {
output += "\n               <i class=\"bar ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"className"), env.opts.autoescape);
output += "\"></i>\n               <i class=\"dot ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"className"), env.opts.autoescape);
output += "\"></i> \n           ";
;
}
;
}
output += "\n        ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n    <div class=\"express-body-current\">\n        ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "status");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("item", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n           ";
if(runtime.memberLookup((t_8),"active")) {
output += "\n               ";
output += runtime.suppressValue(runtime.memberLookup((t_8),"name"), env.opts.autoescape);
output += "\n           ";
;
}
output += "     \n        ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n    <div class=\"express-body-history\">\n        ";
frame = frame.push();
var t_11 = runtime.contextOrFrameLookup(context, frame, "status_history");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("item", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
output += "\n            <div class=\"history-item\">\n                <span class=\"date\">";
output += runtime.suppressValue(runtime.memberLookup((t_12),"date_of_change"), env.opts.autoescape);
output += " - </span>\n                <span class=\"label\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_12),"name")), env.opts.autoescape);
output += "</span>\n            </div>\n        ";
;
}
}
frame = frame.pop();
output += "\n    </div>\n</div>\n<div class=\"express-note\">\n    <p class=\"address-label\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "shipping"), env.opts.autoescape);
output += "</p>\n    <p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "address")),"first_name"), env.opts.autoescape);
output += "</p> \n    <p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "address")),"address1"), env.opts.autoescape);
output += "</p>\n    <p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "address")),"phone"), env.opts.autoescape);
output += "</p>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/extension/express/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/extension/express/tpl.html
// module id = 357
// module chunks = 0 1